module.exports = __webpack_public_path__ + "img/couple-dancing.e45fac16.png";